export default __webpack_public_path__ + "static/media/ballotnav.77a43536.svg";